import { animate, stagger } from 'animejs';

const sections = document.querySelectorAll('main#MainContent > .shopify-section');

if (sections.length) {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    sections.forEach((section) => section.classList.add('scroll-revealed'));
  } else {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          observer.unobserve(entry.target);
          entry.target.classList.add('scroll-revealed');

          const children = [...entry.target.children].filter((el) => el.tagName !== 'STYLE' && el.tagName !== 'SCRIPT');
          const targets = children.length ? children : [entry.target];

          animate(targets, {
            opacity: [0, 1],
            translateY: [32, 0],
            duration: 900,
            delay: stagger(80),
            ease: 'outQuart',
          });
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -10% 0px' }
    );

    sections.forEach((section) => observer.observe(section));
  }
}
